import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-safety-policy',
  imports: [],
  templateUrl: './safety-policy.component.html',
  styleUrl: './safety-policy.component.css',
})
export class SafetyPolicyComponent implements OnInit  {
  lastUpdated: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute) {
    this.lastUpdated = new Date().toLocaleDateString();
  }

  ngOnInit(): void {}

   /**
   * When user clicks TOS on signup on PWA will be redirect to Angular TOS.
   * Return back to PWA on click back btn
   */
  goBack(): void {
    this.route.queryParamMap.subscribe(params => {
      const redirectBackTo = params.get('redirect-back-to');
      if (redirectBackTo && redirectBackTo == "app") {
        window.location.href = `${environment.pwaFrontendBaseUrl}/auth/signup`;
      } else {
        this.router.navigate([""]);
      }
      console.log("redirectBackTo: ", redirectBackTo);
    });
  }
}
